import { ClockFetchInterval } from "../../../../src/components/react/ClockFetchInterval";
import * as React from 'react';
export default {
  ClockFetchInterval,
  React
};